export default __webpack_public_path__ + "static/media/arrowNeon.29e14ab5.png";